import { render, staticRenderFns } from "./StdRiskTextReview.vue?vue&type=template&id=6e72117c&"
import script from "./StdRiskTextReview.vue?vue&type=script&lang=js&"
export * from "./StdRiskTextReview.vue?vue&type=script&lang=js&"
import style0 from "./StdRiskTextReview.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "StdRiskTextReview.vue"
export default component.exports